import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { apiClient } from 'Module/API/Client'
import DatePicker from 'rc-calendar/lib/Picker'
import Calendar from 'rc-calendar'
import moment from 'moment'
import Table from 'rc-table'
import { createForm } from 'rc-form'
import _ from 'lodash'
import SubmitButton from './../../../../Components/Form/SubmitButton'
import { LinkAdd as AddButton } from './../../../../Components/LinkAdd'

let id = 0
const { getCityBadWeatherSurges } = apiClient

// START: Locale settings
// Creating a locale where first day of week is Monday
moment.defineLocale('en-dow1', {
  parentLocale: 'en',
  week: {
    dow: 8, // 1 - Monday + 7 previous week
  },
})
const localLocale = moment()
localLocale.locale('en-dow1')
// END: Locale settings

const format = 'YYYY-W'
const isInPast = value =>
  value ? value.format('YYYYww') < moment().format('YYYYww') : false
const isInFarFuture = value =>
  value
    ? value.format('YYYYww') >=
      moment()
        .add(2, 'weeks')
        .format('YYYYww')
    : false
class BadWeather extends React.Component {
  columns = [
    {
      width: '25%',
      title: 'Week',
      dataIndex: 'week',
      key: 'week',
      render: (week, { id }, index) => {
        // The temp here is a way to distinguish between the form rows in the table and the non-form rows.
        // Form rows has the temp in their id.
        if (`${id}`.indexOf('temp') === -1) {
          return <span>{week}</span>
        }
        const fieldKey = `week-${id}`
        return (
          <DatePicker
            onOpenChange={this.onOpenChange(index)}
            open={this.state.openCalendarIndex === index}
            animation="slide-up"
            calendar={this.calendar}
            {...this.props.form.getFieldProps(fieldKey, {
              initialValue: null,
              rules: [
                { required: true, message: 'Week is required' },
                {
                  validator: function(rule, value, callback, source, options) {
                    var errors = []
                    if (isInPast(value)) {
                      errors.push(
                        `The week should be in the future. --> ${value.format(
                          format,
                        )}`,
                      )
                      if (isInFarFuture(value)) {
                        errors.push(
                          `The week should be at most 2 weeks in the future. --> ${value.format(
                            format,
                          )}`,
                        )
                      }
                    }
                    callback(errors)
                  },
                },
              ],
            })}
          >
            {({ value }) => {
              return (
                <span tabIndex="0">
                  <input
                    placeholder="please select week"
                    readOnly
                    tabIndex="-1"
                    className={`ant-calendar-picker-input ant-input ${
                      this.hasError(fieldKey) ? 'has-error' : ''
                    }`}
                    value={(value && value.format(format)) || ''}
                  />
                </span>
              )
            }}
          </DatePicker>
        )
      },
    },
    {
      width: '25%',
      title: 'Trigger',
      dataIndex: 'trigger',
      key: 'trigger',
      render: (value, { id }, index) => {
        if (`${id}`.indexOf('temp') === -1) {
          return <span>{value}</span>
        }
        const fieldKey = `trigger-${id}`
        return (
          <input
            type="number"
            min="1"
            max="20"
            className={this.hasError(fieldKey) ? 'has-error' : ''}
            {...this.props.form.getFieldProps(fieldKey, {
              initialValue: '',
              rules: [
                {
                  required: true,
                  validator: function(rule, value, callback, source, options) {
                    var errors = []
                    if (!value) {
                      errors.push('The trigger is required')
                    }
                    if (!_.isNumber(Number(value)) || Number(value) % 1 !== 0) {
                      errors.push('The trigger should be a valid integer')
                    }
                    callback(errors)
                  },
                },
              ],
            })}
          />
        )
      },
    },
    {
      width: '25%',
      key: 'payout',
      dataIndex: 'payout',
      title: 'Payout',
      render: (value, { id }, index) => {
        if (`${id}`.indexOf('temp') === -1) {
          return <span>{value}</span>
        }
        const fieldKey = `payout-${id}`
        return (
          <input
            type="number"
            className={this.hasError(fieldKey) ? 'has-error' : ''}
            {...this.props.form.getFieldProps(fieldKey, {
              initialValue: '',
              rules: [
                {
                  required: true,
                  validator: function(rule, value, callback, source, options) {
                    var errors = []
                    if (!value) {
                      errors.push('The payout is required')
                    }
                    if (!_.isNumber(Number(value))) {
                      errors.push('The payout should be a valid number')
                    }
                    callback(errors)
                  },
                },
              ],
            })}
          />
        )
      },
    },
    {
      title: 'Actions',
      key: 'action',
      render: (value, record, index) => {
        if (`${record.id}`.indexOf('temp') === -1) {
          return ''
        }

        return (
          <button type="button" onClick={() => this.removeItem(record.id)}>
            Remove
          </button>
        )
      },
    },
  ]

  calendar = (
    <Calendar
      className="week-calendar"
      disabledDate={date => isInPast(date) || isInFarFuture(date)}
      showWeekNumber
      format={format}
      style={{ zIndex: 1000 }}
      dateInputPlaceholder="please input"
      defaultValue={localLocale}
      showDateInput
    />
  )
  state = {
    country: {},
    newSurges: [],
    savedSurges: [],
    loading: true,
    serverError: '',
    openCalendarIndex: -1,
  }
  removeItem = idToRemove => {
    const { form } = this.props
    let keys = form.getFieldValue('keys')
    keys = keys.filter(id => {
      return id !== idToRemove
    })
    form.setFieldsValue({
      keys,
    })
  }
  async componentDidMount() {
    const {
      badWeatherSurges: savedSurges,
      country,
    } = await getCityBadWeatherSurges(this.props.cityId)
    this.setState({ savedSurges, loading: false, country })
  }
  addSurge = () => {
    const { form } = this.props
    id++
    let keys = form.getFieldValue('keys')
    keys = keys.concat(`temp-${id}`)
    // important! notify form to detect changes
    form.setFieldsValue({
      keys,
    })
    this.setState({ serverError: '' })
  }
  submit = async e => {
    e.preventDefault()
    // validate
    this.props.form.validateFields(async (error, value) => {
      if (error) {
        return
      }
      // generate array of payoutSurges
      const surges = value.keys.map(key => ({
        trigger: value[`trigger-${key}`],
        payout: value[`payout-${key}`],
        week: value[`week-${key}`].format(format),
      }))
      if (!surges.length) return
      this.setState({ loading: true })
      const res = await apiClient.createCityBadWeatherSurges(
        this.props.cityId,
        surges,
      )
      if (res.error) {
        this.setState({ serverError: res.error, loading: false })
      } else {
        this.setState({
          loading: false,
          savedSurges: [...this.state.savedSurges, ...res],
        })
      }
      this.props.form.setFieldsValue({ keys: [] })
    })
    // parse (week-->format)
  }
  onOpenChange = index => () => {
    this.setState({
      openCalendarIndex: index === this.state.openCalendarIndex ? -1 : index,
    })
  }
  getErrors = () => {
    const { getFieldsError, getFieldValue } = this.props.form
    const keys = getFieldValue('keys')
    const { serverError } = this.state
    let errors = []
    if (serverError) {
      errors.push(serverError)
    }
    const fieldsErrors = getFieldsError()
    let t
    keys.forEach(key => {
      t = fieldsErrors[`payout-${key}`]
      if (t) {
        errors = errors.concat(t)
      }
      t = fieldsErrors[`week-${key}`]
      if (t) {
        errors = errors.concat(t)
      }
      t = fieldsErrors[`trigger-${key}`]
      if (t) {
        errors = errors.concat(t)
      }
    })

    return _.uniq(errors)
  }
  hasError = field => {
    return this.props.form.getFieldError(field)
  }
  render() {
    const { getFieldProps, getFieldValue } = this.props.form
    const { savedSurges } = this.state
    getFieldProps('keys', {
      initialValue: [],
    })
    if (this.state.loading) {
      return 'Loading ...'
    }
    const errors = this.getErrors()
    const data = savedSurges.concat(getFieldValue('keys').map(id => ({ id })))

    return (
      <div className="bad-weather-surges">
        <Row>
          <Col xs={8}>
            <SectionTitle className="section-title">
              Bad Weather Payout Surges
            </SectionTitle>
          </Col>
          <Col xs={4}>
            <AddButton className="add-button" onClickHandler={this.addSurge} />
          </Col>
        </Row>
        <Table
          rowClassName={(record, index) =>
            `bad-weather-row ${index % 2 ? '' : 'bg-grey'}`
          }
          rowKey="id"
          className="table-w-100"
          data={data}
          columns={this.columns}
        />
        <SubmitButton
          className="create-button"
          onClick={this.submit}
          value="Submit Bad Weather Surges"
        />
        {errors.length > 0 && <h3>Errors</h3>}
        <ul className="errors">
          {errors.map((error, index) => (
            <li key={error + index}>{error}</li>
          ))}
        </ul>
      </div>
    )
  }
}
const Form = createForm()(BadWeather)
export default Form



// WEBPACK FOOTER //
// ./src/Containers/Form/City/BadWeather/index.js